import React, { useState, useEffect } from "react";
import { TextField, IconButton } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import PropTypes from "prop-types";
import { vars } from "../../config/theme";
import { MATERIAL_UI_PROPS } from "../../lib/data";

const OrderChangeComponent = (props) => {
    const [enabled, setEnabled] = useState(false);
    const [itemOrder, setItemOrder] = useState(props.item.order);
    const [error, setError] = useState(false);

    useEffect(() => {
        setItemOrder(props.item.order);
    }, [props.item]);

    const switchToDefault = () => {
        setItemOrder(props.item.order);
        setError(false);
    };

    const buttonClick = (e, buttonName) => {
        e.stopPropagation();
        switch (buttonName) {
            case "decline":
                switchToDefault();
                break;
            default:
                break;
        }
        setEnabled(false);
    };

    const keyDownHandler = (e) => {
        if (e.key !== "Enter") return;
        if (error) return;

        changeOrderNum(
            itemOrder,
            props.item,
            props.updateParticularItem,
            buttonClick,
            e,
        );
    };

    const acceptIcon = (
        <IconButton
            disabled={error ? true : false}
            title="Accept"
            onClick={(event) => {
                changeOrderNum(
                    itemOrder,
                    props.item,
                    props.updateParticularItem,
                    buttonClick,
                    event,
                );
            }}
        >
            <DoneIcon style={{ color: error ? vars.inactive : vars.active }} />
        </IconButton>
    );
    const declineIcon = (
        <IconButton
            title="Decline"
            onClick={(e) => {
                buttonClick(e, "decline");
            }}
        >
            <ClearIcon style={{ color: vars.decline }} />
        </IconButton>
    );

    return (
        <TextField
            style={{ maxWidth: "210px" }}
            error={error}
            type="number"
            value={itemOrder}
            disabled={!enabled}
            helperText={
                error &&
                "Значение может быть только целое положительное число не более 255"
            }
            onChange={(e) => {
                setNewOrderNumber(e.target.value, setError, setItemOrder);
            }}
            onClick={() => setEnabled(true)}
            onKeyPress={keyDownHandler}
            size={MATERIAL_UI_PROPS.sizes.small}
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            InputProps={{
                endAdornment: enabled ? (
                    <>
                        {acceptIcon}
                        {declineIcon}
                    </>
                ) : null,
            }}
        />
    );
};

// Helper funcs

/**
 * Sets order number and indicates input mistakes
 *
 * @param {String} numStr
 * @param {Function} setError
 * @param {Function} setItemOrder
 */

const setNewOrderNumber = (numStr, setError, setItemOrder) => {
    const numAsNumber = Number(numStr);
    let numToShow;
    let isIncorrectVal;
    if (
        !Number.isInteger(numAsNumber) ||
        numAsNumber <= 0 ||
        numAsNumber > 255
    ) {
        isIncorrectVal = true;
    } else if (Number.isInteger(numAsNumber) || numAsNumber > 0) {
        isIncorrectVal = false;
    }
    numToShow = isIncorrectVal ? numStr : numAsNumber;

    setError(isIncorrectVal);
    setItemOrder(numToShow);
};

/**
 *
 * Sends request to change order number in backend
 *
 * @param {String} newOrderNum
 * @param {Object} item
 * @param {Function} updateItem
 * @param {Function} setFieldActive
 * @param {Event} event
 */

const changeOrderNum = (
    newOrderNum,
    item,
    updateItem,
    setFieldActive,
    event,
) => {
    const updatedItem = { ...item, order: newOrderNum };
    updateItem(updatedItem);
    setFieldActive(event);
};

OrderChangeComponent.propTypes = {
    item: PropTypes.object,
    updateParticularItem: PropTypes.func,
};

export default OrderChangeComponent;
